import { OMNIO_RESPONSE_CODES } from '../constants/serverResponses'

/**
 * Provides error text depends on error type (or HTTP error code)
 * @param {string} errorType
 * @returns {string}
 */
export const OMNIO_ERROR_TEXT = (l10n, errorType = '') => {
  switch (errorType) {
    case OMNIO_RESPONSE_CODES.AUTH_NOT_FOUND:
    case OMNIO_RESPONSE_CODES.AUTH_INVALID_CURRENCY:
    case OMNIO_RESPONSE_CODES.NOT_FOUND:
    case OMNIO_RESPONSE_CODES.NOT_VALID:
      return l10n.t('COULD_NOT_VALIDATE')
    case OMNIO_RESPONSE_CODES.NOT_ENOUGH_FUNDS:
      return l10n.t('LACK_OF_AMOUNT')
    case OMNIO_RESPONSE_CODES.INVALID_AMOUNT:
    case OMNIO_RESPONSE_CODES.CARD_NOT_FOUND:
      return l10n.t('VALIDATE_ERROR_OMNIO')
    case OMNIO_RESPONSE_CODES.UNKNOWN_ERROR:
      return l10n.t('PLEASE_TRY_AGAIN')
    case OMNIO_RESPONSE_CODES.AUTH_UNAVAILABLE:
    case OMNIO_RESPONSE_CODES.UNAVAILABLE:
      return l10n.t('UNAVAILABLE_OMNIO')
    default:
      return l10n.t('PLEASE_TRY_AGAIN_OTHER')
  }
}
